import { createGlobalState } from 'react-hooks-global-state'

const initialState = { isOpen: false }
const { useGlobalState, setGlobalState } = createGlobalState(initialState)

export default function useAuthPopupState() {
  return useGlobalState('isOpen')
}

export function openAuthPopup() {
  setGlobalState('isOpen', true)
}
